import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import {environment} from '../../../environments/environment';

export class AbstractService {

    protected http: HttpClient;
    protected headers: HttpHeaders;

    protected readonly API_NOTIFICATION = environment.urls.notification;
    // protected readonly API_REST_GEO_ANALISE = environment.urls.geo;
    protected readonly API_REST_SIGEVS = environment.urls.sigevs;
    protected readonly API_REST_PLANILHAS = environment.urls.planilhas;

    constructor(http: HttpClient) {
        this.http = http;
    }

    buildParams(params: any): HttpParams {
        return Object.keys(params).reduce((acc, key) => {
            if (params[key]) {
                if (typeof params[key] === "object") {
                    Object.keys(params[key]).forEach((k) => {
                        acc = acc.set(`${key}.${k}`, params[key][k]);
                    });
                } else {
                    acc = acc.set(key, params[key]);
                }
            }
            return acc;
        }, new HttpParams());
    }
}
